import * as React from 'react'
import styles from './ConversationHeaderBanner.sass'

interface ConversationHeaderBannerProps {
  title: React.ReactNode
  children: React.ReactNode
}

/**
 * Conversation Header Banner
 */
export function ConversationHeaderBanner({
  title,
  children,
}: ConversationHeaderBannerProps) {
  return (
    <div className={styles.root}>
      <div className={styles.title}>{title}</div>
      <div className={styles.content}>{children}</div>
    </div>
  )
}
